import { useCallback, useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import { Link, useOutletContext } from "react-router-dom";
import httpClient from "../../provider/httpClient";

const Role = () => {
  const checkPermissionExists = useOutletContext();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  const fetchRoles = async () => {
    try {
      setLoading(true);
      const response = await httpClient.post(`/role/all`);
      setData(response.data.data);
      setLoading(false);
      setDataLoaded(true);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("useeffect", loading, dataLoaded);
    setDataLoaded(false);
    fetchRoles();
  }, []);

  const handleDelete = useCallback(
    row => async () => {
      console.log(row);
      try {
        await httpClient.delete(`/role/${row.id}`);
        fetchRoles();
      } catch (error) {
        console.error(error);
      }
    },
    []
  );

  const customStyles = {
    headRow: {
      style: {
        fontSize: 'large',
      },
    },
  };

  const columns = useMemo(
    () => [
      {
        name: "#",
        selector: (row, index) => index + 1
      },
      {
        name: "Name",
        selector: row => row.name,
        wrap: true
        //sortable: true
      },
      {
        name: "Permissions",
        cell: row => (
          <div>
            {
              row.permissions.map((obj, i) => (
                <span className="badge badge-primary">{obj.name}</span>
              ))
            }
            .....</div>
        ),
      },
      {
        name: "Created On",
        selector: row => row.created_at,
        format: row => moment(row.created_at).format('YYYY-MM-DD kk:mm:ss'),
        wrap: true
      },
      {
        name: "Actions",
        // eslint-disable-next-line react/button-has-type
        cell: row => <span>
          {
            checkPermissionExists("access_user_management") && <>
              <Link to={`/dashboard/role-form?form_id=${row.id}`} state={{ roleData: row }} ><i className="fas fa-edit" style={{ fontSize: "30px", color: "green", marginRight: "15px" }}></i></Link>
              <i className='fas fa-trash-alt' style={{ fontSize: "30px", color: "red" }} onClick={handleDelete(row)}></i>
            </>
          }
        </span >
      }
    ],
    [handleDelete]
  );

  return (
    <>
      <div className="card shadow mb-4">
        <div className="card-body">
          <div className="row">
            <div className="col">
              {
                checkPermissionExists("access_user_management") &&
                <Link to='/dashboard/role-form?form=0' state={{ roleData: null }} className="btn btn-primary" >Add Role</Link>
              }
            </div>
          </div>
          <DataTable
            title="Roles List"
            columns={columns}
            data={data}
            progressPending={loading}
            striped={true}
          // customStyles={customStyles}
          />
        </div>
      </div>
    </>
  )
}

export default Role;